import * as infiniteHits from './load_more_results';

window.CompanyProjects = {
  _countOnlySearch: {},
  _searchObject: {},
  _facetsSearch: {},

  _initCountOnlySearch(appId, countKey, indexName) {
    return instantsearch({
      searchClient: algoliasearch(appId, countKey),
      indexName,
      routing: false
    });
  },

  _initHitsSearch(appId, hitsKey, indexName) {
    return instantsearch({
      searchClient: algoliasearch(appId, hitsKey),
      indexName,
      routing: false
    });
  },

  _initFacetsSearch(appId, facetsKey, indexName) {
    return instantsearch({
      searchClient: algoliasearch(appId, facetsKey),
      indexName,
      routing: true
    });
  },

  initializeIndex(appId, keys, indexName, view, prefix, env, userId, controller, highLevelMember, isSelfCompany, company, showSectors, userMembership, protenders) {
    this._countOnlySearch = this._initCountOnlySearch(appId, keys.countKey, indexName);
    this._searchObject = this._initHitsSearch(appId, keys.hitsKey, indexName);
    this._facetsSearch = this._initFacetsSearch(appId, keys.facetsKey, indexName);

    const hitsWidgets = [];

    if (view === 'grid') {
      hitsWidgets.push(
        PublicIndexesProjectsWidgets.sortBySelectorWidget(indexName, prefix, env, userMembership, protenders),
        PublicIndexesProjectsWidgets.hitsWidget(view, userId, controller, userMembership, isSelfCompany, company, trial)
      );
    } else if (view === 'map') {
      leafLetMapInit();
      PublicIndexesProjectsWidgets.initAsyncHitsLoading(CompanyProjects, this._searchObject, indexName);
      hitsWidgets.push(instantsearch.widgets.asyncHitsLoading({}));
    } else if (view === 'table') {
      hitsWidgets.push(
        PublicIndexesProjectsWidgets.paginationWidget(),
        PublicIndexesProjectsWidgets.singleHitsWidget(CompanyProjects, view, userId, controller, isSelfCompany, company, trial, userMembership)({}),
        AgGridHeadersSearch.initializeHiddenSearchWidget(prefix, indexName, env)
      );
    } else if (view === 'charts') {
      PublicIndexesProjectsWidgets.initAsyncHitsLoadingBreakdown();
      hitsWidgets.push(instantsearch.widgets.asyncHitsLoadingBreakdown());
    }

    this._searchObject.addWidgets(hitsWidgets);

    if (!userId) {
      this._countOnlySearch.addWidgets([
        PublicIndexesProjectsWidgets.confidentialProjectsCountWidget()
      ]);
    }

    const facetsWidgets = [];

    if (showSectors) {
      facetsWidgets.push(
        PublicIndexesProjectsWidgets.sectorsWidget(),
        PublicIndexesProjectsWidgets.categoryWidget(),
        PublicIndexesProjectsWidgets.statusWidget(),
        PublicIndexesProjectsWidgets.budgetPriceRangeWidget(),
        PublicIndexesProjectsWidgets.completionPercentWidget()
      );
    }

    facetsWidgets.push(
      Widgets.currentRefinedValuesWidget()({}),
      PublicIndexesProjectsWidgets.statsWidget(),
      PublicIndexesProjectsWidgets.searchBoxWidget(I18n.t('projects.keyword_filter.enter_keyword')),
      PublicIndexesProjectsWidgets.descriptionWidget(),
      PublicIndexesProjectsWidgets.locationWidget(),
      PublicIndexesProjectsWidgets.companyActivitiesWidget(),
      PublicIndexesProjectsWidgets.clearAllWidget()
    );

    this._facetsSearch.addWidgets(facetsWidgets);

    if ($('#projects-grid').length > 0) {
      if (userId) {
        return this._searchObject.on('render', function () {
          SearchUtils.adjustViewMode();
          window.advancedSearchFixed();

          return $.cloudinary.responsive();
        });
      } else {
        return this._searchObject.on('render', function () {
          window.advancedSearchFixed();

          if (savvior.ready(".ais-Hits-list")) {
            return savvior.destroy();
          } else {
            return setup_gridview();
          }
        });
      }
    }
  },
};
